module.exports = {
	"pt": {
		"conversation": {
			"widget": {
				"title": "Conversa connosco no chat",
				"subtitle": ""
			}
		}
	}
};